import React from 'react';
import NotificationBell from './NotificationBell';
import { User } from 'lucide-react';

const Header = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div 
      className='h-12 flex items-center justify-end px-6' 
      style={{
        background: 'linear-gradient(90deg, #0F1A36 0%, #0B132B 100%)',
        borderBottom: '1px solid rgba(58, 134, 255, 0.15)'
      }}
      data-testid="header-container"
    >
      <div className='flex items-center gap-4'>
        <NotificationBell />
        
        <div className='flex items-center gap-3 text-white'>
          <div 
            className='w-8 h-8 rounded-full flex items-center justify-center'
            style={{
              background: 'linear-gradient(135deg, rgba(58, 134, 255, 0.2) 0%, rgba(0, 212, 255, 0.2) 100%)',
              border: '1px solid rgba(0, 212, 255, 0.3)',
              boxShadow: '0 0 12px rgba(0, 212, 255, 0.2)'
            }}
          >
            <User className='w-4 h-4 text-[#00D4FF]' />
          </div>
          <div className='text-right'>
            <span className='text-sm font-medium block text-white'>{user.name || 'Usuario'}</span>
            <span className='text-[10px] text-[#00D4FF]/60'>{user.role || ''}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
